var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSitemap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.649,
    height: 17.634,
    viewBox: "0 0 25.649 17.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21985",
    "data-name": "Group 21985",
    transform: "translate(-18017.98 -1154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9788",
    "data-name": "Rectangle 9788",
    width: 9.746,
    height: 5.482,
    rx: 1,
    transform: "translate(18025.963 1154.3)",
    fill: "#00a99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_9788_-_Contorno",
    "data-name": "Rect\\xE1ngulo 9788 - Contorno",
    d: "M.534.534V5.344H9.619V.534H.534M.534,0H9.619a.534.534,0,0,1,.534.534V5.344a.534.534,0,0,1-.534.534H.534A.534.534,0,0,1,0,5.344V.534A.534.534,0,0,1,.534,0Z",
    transform: "translate(18025.727 1154)",
    fill: "#3f348b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9789",
    "data-name": "Rectangle 9789",
    width: 7.31,
    height: 5.482,
    transform: "translate(18027.182 1165.874)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_9789_-_Contorno",
    "data-name": "Rect\\xE1ngulo 9789 - Contorno",
    d: "M.534.534V5.344H7.481V.534H.534M.534,0H7.481a.534.534,0,0,1,.534.534V5.344a.534.534,0,0,1-.534.534H.534A.534.534,0,0,1,0,5.344V.534A.534.534,0,0,1,.534,0Z",
    transform: "translate(18026.797 1165.756)",
    fill: "#3f348b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9791",
    "data-name": "Rectangle 9791",
    width: 7.31,
    height: 5.482,
    transform: "translate(18018.045 1165.874)",
    fill: "#bce037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_9791_-_Contorno",
    "data-name": "Rect\\xE1ngulo 9791 - Contorno",
    d: "M.534.534V5.344h6.68V.534H.534M.534,0h6.68a.534.534,0,0,1,.534.534V5.344a.534.534,0,0,1-.534.534H.534A.534.534,0,0,1,0,5.344V.534A.534.534,0,0,1,.534,0Z",
    transform: "translate(18017.98 1165.756)",
    fill: "#3f348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_170786",
    "data-name": "Trazado 170786",
    d: "M18290.535,228.985H18290v-6.551h.535Z",
    transform: "translate(-259.492 937.007)",
    fill: "#3f348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_170787",
    "data-name": "Trazado 170787",
    d: "M18293.736,228.443h-.533v-3.008h-17.744v3.008h-.535V224.9h18.813Z",
    transform: "translate(-253.727 937.55)",
    fill: "#3f348b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9790",
    "data-name": "Rectangle 9790",
    width: 7.31,
    height: 5.482,
    rx: 1,
    transform: "translate(18036.318 1165.874)",
    fill: "#e01b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_9790_-_Contorno",
    "data-name": "Rect\\xE1ngulo 9790 - Contorno",
    d: "M.534.534V5.344h6.68V.534H.534M.534,0h6.68a.534.534,0,0,1,.534.534V5.344a.534.534,0,0,1-.534.534H.534A.534.534,0,0,1,0,5.344V.534A.534.534,0,0,1,.534,0Z",
    transform: "translate(18035.881 1165.756)",
    fill: "#3f348b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitemap);
export default __webpack_public_path__ + "static/media/Sitemap.ac89b2104ad602ab8c53648a461a4e31.svg";
export { ForwardRef as ReactComponent };